import { getPassengerDetailsAction } from "../../../Actions/LogicActions/Checkout/PassengerDetails/GetPassengerDetailsAction";
import { getPaymentCardsAction } from "../../../Actions/LogicActions/MyAccount/Payments/GetPaymentCardsAction";
import { getLoyaltyProgramAction } from "../../../Actions/LogicActions/MyAccount/LoyaltyProgram/GetLoyaltyProgramAction";
import { getCMSAboutLoyaltyProgramAction } from "../../../Actions/LogicActions/MyAccount/LoyaltyProgram/GetCMSAboutLoyaltyProgramAction";
import { ILoyaltyProgramActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/LoyaltyProgramActionParams";
import { IAboutLoyaltyProgramResponse } from "../../../Orchestrator/Types/Interface/ICmsAboutLoyaltyProgram";
import { updateAccountProgressAction } from "../../../Actions/LogicActions/MyAccount/UpdateAccountProgressAction";
import { fetchVouchersAction } from "../../../Actions/LogicActions/Voucher/FetchVouchersAction";
import { accountMenuClickAction } from "../../../Actions/UIActions/MyAccount/AccountMenuClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { ILoyaltyProgramResponse } from "../../../Orchestrator/Types/Interface/ILoyaltyProgram";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { myAccountTree } from "../../../Orchestrator/ConstantTree";
import { getRecoilStateValue } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUserResponse } from "../../../Orchestrator/Types/Index";
import { IFetchVouchersActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { MyAccountContext } from "../Context/MyAccountContext";
import { loyaltyProgramPostAction } from "../../../Actions/LogicActions/MyAccount/LoyaltyProgram/PostLoyaltyProgramAction";
import { getCustomerTiersAction } from "../../../Actions/LogicActions/MyAccount/LoyaltyProgram/GetCustomerTiersAction";
import { getCmsAccountBannerAction } from "../../../Actions/LogicActions/MyAccount/GetCmsAccountBannerAction";

export class MyAccountInitStep extends StepFlow {
  get stepName() { return "MyAccountInit_Step"; }

  async onEventSetup(): Promise<void> {

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.paymentCards.Get,
        handler: async () => {
          const userData = getRecoilStateValue<IUserResponse>("userDataAtom");
          if (userData?.userId) {
            getPaymentCardsAction.setParams({ userId: userData.userId })
            await getPaymentCardsAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.paymentCards.Vouchers.Get,
        handler: async () => {
          const userData = getRecoilStateValue<IUserResponse>("userDataAtom");
          if (userData?.id) {
            const params: IFetchVouchersActionParams = {
              userId: userData.id
            }
            fetchVouchersAction.setParams(params)
            await fetchVouchersAction.execute()
          }
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.MyAccount.Init,
        handler: async () => {
          // await getUserDetailsAction.execute();
          await getPassengerDetailsAction.execute();
          if (getPassengerDetailsAction.result) {
            let context = this.getCtx<MyAccountContext>("myAccountContext");
            if (context) {
              context.userDetails = getPassengerDetailsAction.result.customerData;
            }
            _eventBus.emit({
              eventName: myAccountTree.loyaltyProgram.get,
            });
            _eventBus.emit({
              eventName: myAccountTree.paymentCards.Get,
            });

            _eventBus.emit({
              eventName: myAccountTree.paymentCards.Vouchers.Get,
            });
          }
        }
      })
    )


    const eventHandlers: { off: () => void }[] = [];
    let hasTriggeredLoyaltyJoin = false;
    eventHandlers.push(
      _eventBus.on({
        eventName: myAccountTree.MyAccount.Action.Click,
        handler: async (data: any) => {
          let newMyAccountTab = data.data;
          let context = this.getCtx<MyAccountContext>("myAccountContext")!;

          let newRoute = context.routeTo ?? [];

          if (data.data === "myAccount") {
            newRoute = ["MyAccountInit_Step"];
            newMyAccountTab = "";
          } else if (data.data === "loyaltyProgramDetail") {
            newRoute = ["LoyaltyProgramDetailFlow"];
          } else if (data.data === "pointsHistory") {
            newRoute = ["PointsHistoryFlow"];
          } else if (data.data === "personalInformation") {
            newRoute = ["PersonalInformationFlow"];
          } else if (data.data === "personalizeExperience") {
            newRoute = ["PersonalizeExperienceFlow"];
          } else if (data.data === "companions") {
            newRoute = ["CompanionSettingFlow"];
          } else if (data.data === "accountManagement") {
            newRoute = ["SettingsFlow"];
          } else if (data.data === "paymentVouchers") {
            newRoute = ["MyAccountPaymentsFlow"];
          }

          accountMenuClickAction.setParams(newMyAccountTab);
          await accountMenuClickAction.execute();

          // Check if old and new route are the same, If not then move to the new route.
          if (
            !(
              context.routeTo?.length === 1 &&
              context.routeTo[0] === newRoute[0]
            )
          ) {
            context.routeTo = newRoute;
            _eventBus.emit({
              eventName: myAccountTree.exitStep,
            });
            this.next();
          }
        },
      })
    );

    eventHandlers.push(
      _eventBus.on({
        eventName: myAccountTree.MyAccount.SignOut.Click,
        handler: () => {
          // All cleanup (localStorage, sessionStorage, caches) and the
          // Keycloak redirect are handled inside useAuth.logout(), which
          // listens for USER_LOGOUT.  Do NOT call signOutAction here --
          // it creates a race condition where localStorage is cleared
          // before the microtask-scheduled logout runs, and then
          // UPDATE_REC_STATE handlers re-populate it.
          _eventBus.emit({ eventName: 'USER_LOGOUT', data: null });
        },
      })
    );

    eventHandlers.push(
      _eventBus.on<number, void>({
        eventName: myAccountTree.PersonalInformation.Percentage.Change,
        handler: async (data: any) => {
          updateAccountProgressAction.setParams(data.data!);
          await updateAccountProgressAction.execute();

          // Auto-enroll into the loyalty program on profile completion is disabled
          // for now (pending an explicit user-consent flow).
          // const user = data.data?.userData;
          // const progress = getRecoilStateValue<number>("accountProgressAtom") || 0;
          // const existingLoyaltyData = getRecoilStateValue<ILoyaltyProgramResponse | null>("loyaltyProgramDataAtom");
          // const loyaltyDataLoaded = typeof existingLoyaltyData !== "undefined";
          // if (!loyaltyDataLoaded) return;
          // const isEligibleToJoin = user?.id && progress >= 100 && !existingLoyaltyData?.loyaltyProgram;
          // if (isEligibleToJoin && !hasTriggeredLoyaltyJoin) {
          //   hasTriggeredLoyaltyJoin = true;
          //   const params: ILoyaltyProgramActionParams = { userId: user.id };
          //   loyaltyProgramPostAction.setParams(params);
          //   await loyaltyProgramPostAction.execute();
          // }
        },
      })
    );

    eventHandlers.push(
      _eventBus.on({
        eventName: myAccountTree.unregisterAllEvents,
        handler: () => {
          eventHandlers.forEach((handler) => handler?.off());
          hasTriggeredLoyaltyJoin = false;
          this.setCtx("eventHandlers", []);
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<number, void>({
        eventName: myAccountTree.loyaltyProgram.get,
        handler: async () => {
          const userData = getRecoilStateValue<IUserResponse>("userDataAtom");
          if (userData?.userId) {
            getLoyaltyProgramAction.setParams({ userId: userData.id })
            await getLoyaltyProgramAction.execute();
          }

          // Auto-enroll after loyalty data is fetched is disabled for now
          // (pending an explicit user-consent flow).
          // const progress = getRecoilStateValue<number>("accountProgressAtom") || 0;
          // const loyaltyData = getRecoilStateValue<ILoyaltyProgramResponse | null>("loyaltyProgramDataAtom");
          // if (userData?.id && progress >= 100 && !loyaltyData?.loyaltyProgram && !hasTriggeredLoyaltyJoin) {
          //   hasTriggeredLoyaltyJoin = true;
          //   const params: ILoyaltyProgramActionParams = { userId: userData.id };
          //   loyaltyProgramPostAction.setParams(params);
          //   await loyaltyProgramPostAction.execute();
          // }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.loyaltyProgram.tiers,
        handler: async () => {
          getCustomerTiersAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.exitStep,
        handler: () => {
          this.next();
        },
      })
    );

    this.setCtx("eventHandlers", eventHandlers);
  }

  async onExecute(): Promise<void> {
    // this.setCtx("myAccountContext", MyAccountContext);
    const myAccountContext = new MyAccountContext();
    this.setCtx("myAccountContext", myAccountContext);
    console.log("Account Page Initialize.....");

    // Fetch the CMS-managed account banner image (falls back to the bundled
    // asset in AccountCompletion when the CMS entry is not yet available).
    getCmsAccountBannerAction.execute();
  }
}

export const MyAccountInitStepDeclaration = new StepDefinition({
  stepName: "MyAccountInit_Step",
  stepClass: MyAccountInitStep,
});
